module.exports = __webpack_public_path__ + "static/media/cert-1.09483f38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/security/3/cert-1.svg
// module id = 404
// module chunks = 0